import {IMessageData} from "../../index";
import * as ko from "knockout";
import {nsFa} from "../fa/fn";
import ifa = nsFa.ifa;
import simple_messageHtml from './simple-message.html?raw';

export let template: string = simple_messageHtml;

export class viewModel {

    private static CONTAINER_CLASS = "simpleMessage";
    messageData: KnockoutComputed<IMessageData>;
    getContainerClasses = ko.pureComputed(this.produceContainerClasses, this);
    getIconClasses = ko.pureComputed(() => {
        switch (this.messageData()?.type) {
            case "danger":
                return ifa("fa-times-circle");
            case "warning":
                return ifa("fa-exclamation-triangle");
            case "success":
                return ifa("fa-check-circle");
            case null:
                return '';
            default:
            case "info":
                return ifa("fa-info-circle");
        }
        return "";
    });
    private containerClasses: string[];

    constructor(private params: any) {
        this.messageData = params.messageData;
        this.containerClasses = params.containerClasses;
    }

    produceContainerClasses(): string {
        let classes = [viewModel.CONTAINER_CLASS];
        if (this.containerClasses) {
            classes = classes.concat(this.containerClasses);
        }
        let type = this.messageData()?.type;
        if (type === undefined) {
            type = "info";
        }
        if (type) {
            classes.push("alert", "alert-" + type);
        }
        return classes.join(" ");
    }

}
